import React from 'react';
import './login.css'
import logo from '../assets/logo.png'
import Input from '../component/common/input';
import CTA from '../component/common/cta';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import pic56 from '../assets/pic56.png'
import pic57 from '../assets/pic57.png'

const Loginpage = () => {


 const [useremail, setUseremail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});


    const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValidLogin =
    useremail === 'salma@workspace.eg' && password === '123456';

const [showPassword, setShowPassword] = useState(false);


    return ( 
        <>
        <section className='sec1'>

            <article className='logincard-container'>
                <article className='sub-cont1-login'>
                    <img src={logo} alt='logo'></img>
                    <h3 className='para-login'>log in to access the admin dashboard</h3>
                </article>

                <form className='form'>

                    <h1 className='header-loginn'>Admin Login</h1>




                      <Input 
                title='Email Address'
              placeholder='admin@workspace.eg'
              value={useremail}
              onChange={(e) => setUseremail(e.target.value)}
              error={errors.useremail}
                />


                        <fieldset className="password-input-container">
                        <Input 
                            title='Password'
                            placeholder='Enter your password'
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={errors.password}
                        />

                            <img
                                src={showPassword ? pic57 : pic56}
                                alt="toggle password"
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </fieldset>

                    <fieldset className='big-cont-remember-me'>
                            <fieldset className="checkmark-cont">
                    <label className="custom-checkbox">
                                    <input className='boxx-custom-checkboxx'
                                        type="checkbox"
                                    />
                                    <span className="checkmark"></span>
                                    Remember me
                                    </label>
                            </fieldset>

                        <h2 className='forgot_password'>Forgot password?</h2>
                    </fieldset>



                            <Link
                                to={
                                isValidLogin
                                ? "/dashboard"
                                : (useremail.trim() &&
                                    isValidEmail(useremail) &&
                                    password.trim())
                                ? "/no-access"
                                : "#"}
                                className="link"
                                onClick={(e) => {
                                let newErrors = {};
                                if (!useremail.trim()) {
                                    newErrors.useremail = 'Email is required';}

                                else if (!isValidEmail(useremail)) {
                                    newErrors.useremail = 'Please enter a valid email address';}

                                if (!password.trim()) {
                                    newErrors.password = 'Password is required';}
                                setErrors(newErrors);
                                if (Object.keys(newErrors).length > 0) {
                                    e.preventDefault();}
                                }}>
                             <CTA title='Log in'/>
                        </Link>


                </form>

                <h3 className='copyrights'>© 2026 Workspace Exhibition. All rights reserved.</h3>
        </article>
        </section>
        </>
     );
}
 
export default Loginpage;